<template>
    <v-container>
      <v-layout wrap>
     <div class="d-flex flex-wrap mb-1 ml-1" v-for="(item, i) in rules" :key="i">
      <v-card
      width="300">
        <v-card-title>{{item.nome}}
          <v-spacer></v-spacer>
          <v-btn icon class="text-end">
                <v-icon color="orange lighten-3">edit</v-icon>
              </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-list>
        <v-list-group
            :disabled="load"
            v-for="(mItem, index) in item.drawer"
            :key="index"
            :value="true"
            :prepend-icon="mItem.icon"
             no-action
            sub-group
          >
        <template v-slot:activator>
          <v-list-item-title>{{mItem.nome}}</v-list-item-title>
        </template>
          <v-list-item
            v-for="(sub, i) in mItem.subItem"
            :key="i"
          >
            <v-list-item-title v-text="sub.nome"></v-list-item-title>

            <v-list-item-icon>
              <v-icon v-text="sub.icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
      </v-list-group>
    </v-list>
        <!-- <v-list>
          <v-list-item
            :disabled="load"
            v-for="(mItem, index) in item.drawer"
            :key="index"
          >
            <v-list-item-action>
              <v-icon>{{mItem.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{mItem.nome}}</v-list-item-title>
            </v-list-item-content>
            <v-list-group
              :disabled="load"
              v-for="sub in mItem.subItem"
              :key="sub.nome"
              :prepend-icon="sub.icon"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="sub.nome"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                :disabled="load"
                  v-for="subItem in item.subItem"
                  :key="subItem.op"
                  @click="rotas(subItem)"
                >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.nome"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item>
      </v-list> -->
      </v-card>
      </div>
      </v-layout>
    </v-container>
</template>

<script>

import ruleService from '../services/ruleservice'

export default {
  components: {},
  data () {
    return {
      rules: '',
      load: false
    }
  },
  methods: {
    getRules () {
      ruleService.getRules().then(r => {
        if (r.status === 200) {
          this.rules = r.data.msg
        }
      })
    }
  },
  mounted () {
    this.getRules()
  }
}
</script>
